<template>
  <div v-if="ticket">
    <Card>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-4 mb-2">
         <label> شماره : </label>
          #{{ticket.number}}
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <label>ثبت کننده : </label>
          {{user.title}}({{user.phone}})
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <label>تاریخ ایجاد : </label>
          {{ticket.createdAt}}
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <label>موضوع : </label>
          {{ticket.subject}}
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <label>دپارتمان : </label>
          <span>{{ticket.department_title}}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          <label>آخرین به روزرسانی : </label>
          <span>{{ticket.updatedAt}}</span>
        </div>
        <div v-if="ticket.last_admin" class="col-12 col-sm-12 col-md-4 mb-2">
          <div>
            <label>آخرین ویرایش مدیریت توسط : </label>
            <span>{{ticket.admin}}</span>
          </div>
          <div>
            {{ticket.last_edit_date}}
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2">
          وضعیت فعلی :
          {{ticket.status_label}}
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-2" v-if="ticket.status !== 'closed'">
          <button @click="closeTicket" class="btn btn-danger px-4 btn-sm">بستن تیکت&nbsp;&nbsp;<i class="far fa-times-circle"></i></button>
        </div>
      </div>
    </Card>
    <div class="answer-div">
      <div class="header collapsed" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
        <div><i class="far fa-pen-alt"></i>&nbsp;&nbsp;پاسخ</div>
        <div><i class="far fa-times open-icon"></i></div>
      </div>
      <div class="body collapse" id="collapseExample">
        <AjaxForm :route="'admin/Ticket/AddPost/'+ticket._id" :callback="addPostCallback" :page-loading="true">
          <label>پیام :</label>
          <input type="hidden" name="content" v-model="content" hidden readonly >
          <editor v-model="content" api-key="f60dl4sz819mfm6cps7g9825ms3y9brgz2hlbiwc610e2mbd"
                  :init="{
                     language: 'fa',
                     directionality : 'rtl',
                     menubar: false,
                     toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignright aligncenter alignleft alignjustify | \
                     bullist numlist outdent indent | removeformat'}"
          ></editor>
          <div class="mt-2">
            <CustomInput v-model="status_selected" label="انتخاب وضعیت"
                         :not-select-append-to-body="!!request_id"
                         select-label="title" reduce_select="value" placeholder="وضعیت را انتخاب کنید"
                         type="select" name="status" :select-options="status_options"></CustomInput>
          </div>
          <div class="mt-2"> ضمیمه ها :
            <button @click="addFile" type="button" class="btn btn-info btn-sm">افزودن فایل&nbsp;<i
                class="far fa-plus"></i></button>
          </div>
          <div class="files row">
            <div class="col-6 my-2" v-for="(item,index) in files" :key="index">
              <input type="file" name="file" class="form-control" placeholder="فایل مورد نظر خود را انتخاب کنید">
            </div>
          </div>
          <div class="row">
            <div class="col-10 col-sm-8 col-md-4 mx-auto my-3">
              <button type="submit" class="btn btn-info btn-block">ارسال</button>
            </div>
          </div>
        </AjaxForm>
      </div>
    </div>

    <div v-for="(post) in posts" :key="post" :class="'post-item '+(post.user_type === 'user'?'user':'admin')">
      <div v-if="post.user_type === 'admin'" class="header admin">
        <div><i class="fas fa-user"></i>&nbsp;&nbsp;{{post.user.fullname}}</div>
        <div>{{post.createdAt}}</div>
      </div>
      <div v-if="post.user_type === 'user'" class="header user">
        <div><i class="fas fa-user"></i>&nbsp;&nbsp;{{user.title}}</div>
        <div>{{post.createdAt}}</div>
      </div>
      <div class="body" v-html="post.content"></div>
      <div v-if="post.file_names && post.file_names.length" class="p-2">
        ضمیمه ها:
        <div  class="files-div">
          <a :href="prefix+f" target="_blank" v-for="f in post.file_names" :key="f" class="file">
            <img :src="prefix+f" alt="">
          </a>
        </div>
      </div>

    </div>
  </div>
  <Card v-if="error">
    <div class="alert alert-danger">{{error}}</div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import Editor from '@tinymce/tinymce-vue'
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {showSystemNoti, showToast} from "@/shared/helper";
import Swal from "sweetalert2";
export default {
  name: "TicketView",
  props : ['request_id'],
  components: {CustomInput, AjaxForm, Card,Editor},
  data()
  {
    return{
      content : '',
      ticket : null,
      posts : [],
      error : null,
      user : null,
      files : [],
      id : this.$route.params.id,
      prefix : process.env.VUE_APP_API_URL+process.env.VUE_APP_USER_STORAGE,
      status_options : [
        {title : 'پاسخ داده شده',value : 'answered'},
          {title : 'بسته شده',value : 'closed'},
          {title : 'درحال انجام',value : 'doing'},
          ],
      status_selected : {title : 'پاسخ داده شده',value : 'answered'},
    }
  },
  mounted()
  {
    if (!this.request_id)
    {
      this.setPageLoading(false);
      this.setPageTitle('مشاهده تیکت');
      this.setShowHead(true);
    }
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.content = '';
      this.id = this.$route.params.id;
      if (!this.id && this.request_id)
      {
        this.id = this.request_id;
      }
      this.error = null;
      this.ticket = null;
      this.posts = [];
      this.setPageLoading(true);
      const result = await AppApi.getTicketInfo(this.id);
      if (result.ok)
      {
        this.ticket = result.ticket;
        this.posts = result.posts;
        this.user = result.user;
      }
      else
          this.error = result.error;
      this.setPageLoading(false);
    },
    addFile()
    {
      this.files.push('');
    },
    async addPostCallback(data)
    {
      if (data.ok)
      {
        showSystemNoti('success',data.message);
        this.initPage();
      }
      else
          return showSystemNoti('danger',data.error);
    },
    async closeTicket()
    {
      const self = this;
      Swal.fire({
        title: 'مطمئن هستید؟',
        html: 'تیکت بسته می شود',
        icon : 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید',
        cancelButtonText: 'انصراف',
        hideClass: {
          popup: 'animate__animated animate__backOutLeft'
        }
      }).then(async (result) => {
        if (result.value)
        {
          const data = await AppApi.closeTicket(self.ticket._id);
          if (data.ok)
          {
            showToast('success',data.message);
            self.initPage();
          }
          else
            showSystemNoti('danger',data.error);
        }
      })
    }
  }
}
</script>

<style scoped>
.post-item
{
  background: white;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.post-item .header
{
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.post-item .header.user
{
  background: #2bbdf7ba;
  color: black;
}
.post-item .header.admin
{
  background: #49ca49a3;
}
.post-item .body
{
  padding: 10px;
}
.post-item.user {
  border: 1px solid #2bbdf7ba;
}
.post-item.admin {
  border: 1px solid #49ca49a3;
}
.files-div
{
  display: flex;
  margin-bottom: 10px;
  margin-top: 5px;
}
.files-div .file
{
  display: block;
  flex: 0 0 60px;
  height: 60px;
  margin-right: 5px;
}
.files-div img
{
  width: 100%;
  height:100%;
  object-fit: contain;
}
.answer-div {
  margin-bottom: 10px;
  border: 1px solid #c9e2ce;
  border-radius: 5px;
  overflow: hidden;
}
.answer-div .header {
  padding: 5px;
  background: #c9e2ce;
  display: flex;
  justify-content: space-between;
}
.answer-div .body
{
  background: white;
  padding: 10px;
}
.answer-div .open-icon
{
  display: block;
  transition: 300ms;
}
.answer-div .header.collapsed .open-icon
{
  transform: rotate(222deg);
}
</style>